import {
    CheckOutlined, CloseOutlined
} from '@ant-design/icons';
import { Col, message, Row, Switch } from 'antd';
import { Component } from "react";
import { connect } from "react-redux";
import { getGlobalConfig, setGlobalConfig } from "../../utils/api";
import { GLOBAL_CONFIG } from "../../utils/enums";


class ScanSettingsView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            scan_use_watermark: false,
        }
    }

    getData = () => {
        getGlobalConfig().then(response => {
            if (response.status !== 200) {
                message.error("Error in getting config");
            } else {
                this.setState({
                    scan_use_watermark: response.data[GLOBAL_CONFIG.ADD_WATERMARK_SCAN.key],
                })
            }
        }).catch(err => console.log(err))
    };

    setData = (key, value) => {
        setGlobalConfig(key, value).then(res => {
            if (res.status !== 200) {
                console.error("Error in setting " + key);
            }
        }).catch(err => console.log(err))
    };

    componentDidMount = () => {
        this.getData();
    }

    onAddWatermarkChange = (checked, event) => {
        this.setState({
            scan_use_watermark: checked
        });
        this.setData(GLOBAL_CONFIG.ADD_WATERMARK_SCAN.key, checked ? "true" : "false");
        message.info(checked ? "Add Watermark is now ON" : "Add Watermark turned off");
    }

    render() {
        return (<div id="scanner-div">
            <Row>
                <Col className="scanner-name arial-font" span={24}>
                    {"Scan Settings"}
                </Col>
            </Row>
            <br></br>
            <br></br>
            <Row>
                <Col span={12}>
                    <Row>
                        <Col span={6} offset={1}>
                            Add Watermark to scans
                        </Col>
                        <Col span={15}>
                            <Switch
                                checkedChildren={<CheckOutlined/>}
                                unCheckedChildren={<CloseOutlined/>}
                                checked={this.state.scan_use_watermark}
                                onChange={this.onAddWatermarkChange}
                            />
                        </Col>

                    </Row>
                </Col>
            </Row>
        </div>)
    }
}

const mapStateToProps = (state, ownProps) => {
    return {};
};

export default connect(mapStateToProps)(ScanSettingsView);
